export enum ChartType {
  Area = 'area',
  Bar = 'bar',
  Graph = 'graph',
  Line = 'line',
  Matrix = 'matrix',
  Number = 'number',
  Pie = 'pie',
  Table = 'table',
  Status = 'status',
  Markdown = 'markdown',
}
